/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

export enum DataModelFilters {
  table = 'table',
  details = 'details',
  showOnTable = 'showOnTable',
  showOnDetailsView = 'showOnDetailsView',
  showOnSearch = 'showOnSearch',
  formCreation = 'formCreation',
  formUpdate = 'formUpdate',
  form = 'form',
  formHidden = 'formHidden',
  preselection = 'preselection',
  quickFormCreation = 'quickFormCreation',
  quickFormUpdate = 'quickFormUpdate'
}
